import { Component, Input, OnInit } from '@angular/core';
import { TreeItem } from '../models/tree-item';

@Component({
  selector: 'connect-replication-detail',
  templateUrl: 'connect-replication-detail.component.html',
  styleUrls: ['connect-replication-detail.component.scss']
})
export class ConnectReplicationDetailComponent implements OnInit {

  public selectedTab: number = 0;
  @Input() currentItemSelected: TreeItem;

  constructor() {
  }

  ngOnInit() {
  }

}
